import React from 'react'
import { Link } from 'react-router-dom';

function Expobz() {
    const images = [
        {
          src: "images/daisypre.jpg",
          title: "Modern Design",
          description: "Available in 91 or 100 cm wide and 120 or 135 cm high models.",
        },
        {
          src: "images/daisypre1.jpg",
          title: "Refrigerated Storage",
          description: "Models with refrigerated understorage and independent temperature control for quick product replenishment.",
        },
        {
          src: "images/daisypre2.jpg",
          title: "Easy Access",
          description: "Front glass with gas strut for easy access and cleaning of the display unit.",
        },
      ];
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/islands" className="block py-1 pl-4 hover:underline mt-6">Islands -</Link>
           <span className="block py-1 pl-4 mt-6">EXPO BZ</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/expobz.png" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">EXPO BZ</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">The high performance panoramic display which increase impulse purchases.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">EXPO BZ is a refrigerated plug-in island ideal for sales and promotional actions. Quickly and effectively display your packed products such as Meat, Charcuterie, Fruit & Vegetables, Drinks, Dairy Products and Pastry wherever is more convenient.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">

       <p className="text-xl lg:text-2xl opacity-90">Packaged foods<span className=' text-blue-400'> -1… +5 °C</span>(3M1)</p>
    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
         
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-6">R290</p>

         </div>
    
   


         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Effective product promotion with low energy consumption</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Fan-assisted cooling that combines optimized air ducts for a soft and balanced air curtain that ensures uniform temperature distribution and reduces heat entering the display. The EXPO BZ merchandiser guarantees the correct conservation of your packaged products with the lowest energy consumption.</div>

    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>High performance, low energy consumption, visibility and low noise for the best shopping experience.</div>

</div>
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/expocase.png" className="max-w-full h-auto object-contain" />
               </div>
             </div>
         </div>
    
         <div className="mt-6">
    <div className="p-4">
      <img src="images/expopre.jpg" alt="Banner" className="w-full object-cover" />
      <p className="text-gray-700 text-xl md:text-4xl text-center mt-6">Stand out even more, your campaigns and promotions!</p>
      <p className="text-gray-700 font-thin  text-xl md:text-2xl mt-4">A 360° all-glass panoramic display unit with acrylic air ducts offers total visibility of your products without obstacles.</p>
    </div>
  </div>

    {/* card & description */}
    <div className="flex flex-wrap gap-6 justify-center mt-16">
  {[
    {
      img: "images/expocard.jpg",
      tittle:"Energy efficient automatic defrost system",
      text: "Automatic hot water defrost system, up to 80% on energy savings when compared to a conventional defrost system.",
    },
    {
      img: "images/expocard1.png",
      tittle:"Save on your electricity bill, even after you close the shop",
      text: "As an optional extra, the EXPO BZ refrigerated island night blind reduces cold losses when it's not in use and thus saves even more energy.",
    },
    {
      img: "images/expocard2.png",
      tittle:"Plug-in merchandiser always where you need it most",
      text: "With an integral condenser unit (plug-in) and a robust set of castors wheels, it is quick and easy to move the EXPO BZ island to any location of your store.",
    },
   
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-black max-w-sm">
        {item.tittle}
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>


 {/* case 3 */}
 <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                  {/* ✅ Image Wrapper */}
  <div className="w-full md:w-1/2">
                 <img src="/images/expocase1.jpg" className="max-w-full h-auto object-contain" />
               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl md:text-4xl">Easy and simple cleaning and maintenance</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Internal components easy to remove and clean, simplify cleaning and maintenance operations.</div>
</div>

             </div>
     </div>
    
  
        </div>
      )
    }

export default Expobz